import { AbilityBuilder, PureAbility } from '@casl/ability';

export type Action = 'view' | 'edit' | 'manage';
export type Subject = string;
export type AppAbility = PureAbility<[Action, Subject]>;

const VALID_ACTIONS: ReadonlySet<string> = new Set(['view', 'edit']);

export function buildAbility(permissions: string[], isSuperAdmin: boolean): AppAbility {
	const { can, build } = new AbilityBuilder<AppAbility>(PureAbility);

	if (isSuperAdmin) {
		can('manage', 'all');
		return build();
	}

	for (const key of permissions) {
		const idx = key.lastIndexOf('.');
		if (idx === -1) continue;
		const action = key.slice(idx + 1);
		const subject = key.slice(0, idx);
		if (!VALID_ACTIONS.has(action)) continue;
		can(action as Action, subject);
		// `edit` implies `view` — backend grants only the highest level per
		// subject (matrix has no "X.view" when X.edit is granted).
		if (action === 'edit') {
			can('view', subject);
		}
	}

	return build();
}
